export { GoldenCard } from './GoldenCard';
